import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { RouterModule } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  providers: [NgbModalConfig, NgbModal]
})
export class FooterComponent implements OnInit {
  @ViewChild('closebutton') closebutton: any;
  year!: number;
  imgSrc = environment.imgBasURL;
  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
    this.year = new Date().getFullYear();

  }


}
